<script>
    import { faPlus } from "@fortawesome/free-solid-svg-icons";
    import {
        Dialog,
        DialogOverlay,
        DialogTitle,
        DialogDescription,
    } from "@rgossiaux/svelte-headlessui";
    import { createEventDispatcher } from "svelte";
    import Fa from "svelte-fa";
    import Button from "../ui/Button.svelte";
    import ButtonAdd from "../ui/ButtonAdd.svelte";
    import TextInput from "../ui/TextInput.svelte";

    const dispatch = createEventDispatcher();

    let newDevice = {
        type: "device",
    };

    function confirm() {
        dispatch("add", newDevice);
        newDevice = {
            type: "device"
        };
        open = false;
    }

    function cancel() {
        open = false;
    }

    let open = false;
</script>

<Dialog class="dialog" open={open} on:close={cancel}>
    <DialogOverlay class="dialog-overlay"/>
    <div class="dialog-content">
        <DialogTitle class="dialog-title">Gerät hinzufügen</DialogTitle>
        <DialogDescription class="dialog-description">
            Lege ein Gerät an, dass mit deinem Account verbunden werden soll. Scanne anschließend den Log-In Code mit dem entsprechenden Gerät ein.
        </DialogDescription>
        
        <form on:submit|preventDefault={confirm}>
            <TextInput
                label="Name"
                bind:value={newDevice.name}
            />
            <!-- <label>Name
                <input bind:value={newDevice.name} type="text">
            </label> -->
            <!-- <label>Typ 
                <select bind:value={newDevice.type}>
                    <option value="device">Gerät</option>
                    <option value="nfc">NFC-Tag</option>
                </select>
            </label> -->
            
            <div class="dialog-options">
                <Button type="button" on:click={cancel}>
                    Abbrechen
                </Button>
                <Button type="submit" intent="primary">
                    Hinzufügen
                </Button>
            </div>
        </form>
    </div>
</Dialog>

<!-- <button on:click={() => {open = true}}>Gerät hinzufügen</button> -->
<!-- <Button intent="primary" on:click={() => {open = true}}>
    <Fa icon={faPlus} slot="icon"/>
    hinzufügen
</Button> -->

<ButtonAdd on:click={() => {open = true}}>
    <Fa icon={faPlus} slot="icon"/>
</ButtonAdd>